import CardItem from "components/PurpleTheme/CardItem";
import React, {useState} from "react";

import { Link } from "react-router-dom";
import { Row, Col, UncontrolledTooltip } from "reactstrap";
import InitialsAvatar from "pages/Profile/InitialsAvatar";
import profileImg from "../../assets/images/profile.png";
import { getUserColor } from "helpers/component_helpers";


const RcaActionItemsList = ({data, all_users}) => {
  const headers = [
    {name: "Name", width: 2, justify: "center"},
    {name: "Status", width: 1, justify: "center"},
    {name: "Due date", width: 2, justify: "center"},
    {name: "Type", width: 2, justify: "center"},
    {name: "Done date", width: 2, justify: "center"},
    {name: "Assigned to", width: 2, justify: "center"}
  ]

  const getDate = (timestamp) => {
    const timestampObj = new Date(timestamp);
    const date = timestampObj.toLocaleDateString('en-GB', { timeZone: 'UTC' });
    return date;
};

  const [allCheckBox, setAllCheckBox] = useState(false);
  const [checkBox, setCheckBox] = useState({});

  const handleCheckBox = (key) => {
    let checkBoxObj = {};
    Object.assign(checkBoxObj, checkBox);
    if (checkBoxObj[key] === true) {
      delete checkBoxObj[key];
    } else {
      checkBoxObj[key] = true
    }
    setCheckBox(checkBoxObj);
    setAllCheckBox(false);
  }

  const handleAllCheckBox = () => {
    let checkBoxObj = {}
    if (allCheckBox === true) {
      data.map((item, index) => {
        delete checkBoxObj[index];
      })
      setCheckBox({});
      setAllCheckBox(false);
    } else {
      data.map((item, index) => {
        checkBoxObj[index] = true
      })
      setCheckBox(checkBoxObj);
      setAllCheckBox(true);
    }
  }

  return(
  <React.Fragment>
    <div>
      <div className="header px-0 mt-4">
        <div className="resources-header-card">
            <Row className="align-items-center pt-2">
              <Col md={1} lg="1">
                  <div className="mb-1 text-center">
                    {allCheckBox ?
                        <i className="bx bx-check-square bx-sm" onClick={() => handleAllCheckBox()}></i>
                        :
                        <i className="bx bx-square bx-sm" onClick={() => handleAllCheckBox()}></i>
                    }
                  </div>
              </Col>
              {headers.map((header, index) => (
                  <Col md={header.width} lg={header.width} key={index}>
                      <div className="d-flex align-items-center justify-content-center">
                          {header.name}
                      </div>
                  </Col>
              ))}
            </Row>
        </div>
      </div>
      <div className="scrollable-container-transparent">
        {(data) ? 
          data.map((item, index) => (
            <div className="my-3" key={index}>
              <CardItem className="px-1 py-1">
                <Row>
                  <Col lg={1} className="d-flex align-items-center justify-content-center">
                    <div className="text-center">
                      {checkBox[index] === true ? (
                          <i
                              className="bx bx-check-square bx-sm"
                              onClick={() => handleCheckBox(index)}
                          />
                      ) : (
                          <i
                              className="bx bx-square bx-sm"
                              onClick={() => handleCheckBox(index)}
                          />
                      )}
                    </div>
                  </Col>
                  <Col lg={2} className="d-flex align-items-center justify-content-center resource-name-truncate">
                    <Link className="resource-name-truncate" to={`/RCA?tab=ActionItems&actionItemId=${item.id}`}>{item.title}</Link>
                  </Col >
                  <Col lg={1} className="d-flex align-items-center justify-content-center">{item.status}</Col>
                  <Col lg={2} className="d-flex align-items-center justify-content-center">{getDate(item.target_date)}</Col>
                  <Col lg={2} className="d-flex align-items-center justify-content-center">{item.type}</Col>
                  <Col lg={2} className="d-flex align-items-center justify-content-center">
                    {item.done_date ? getDate(item.done_date) : <span>-</span>}
                  </Col>
                  <Col lg={2} className="d-flex align-items-center justify-content-center">
                    {all_users[item.reviewer]?.profile_picture_url ? (
                        <div className="d-flex align-items-center justify-content-center me-5">
                          <img
                              id={`TooltipTop_reviewer_${index}`}
                              src={all_users[item.assigned_to]?.profile_picture_url}
                              alt="Profile"
                              style={{
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                marginBottom: "10px"
                              }}
                          />
                          <UncontrolledTooltip placement="top" target={`TooltipTop_reviewer_${index}`}>
                            {all_users[item.assigned_to]?.name}
                          </UncontrolledTooltip>
                        </div>
                    ) : ((all_users[item.assigned_to]?.name)  ?
                    <div className="d-flex align-items-center justify-content-center">
                    <InitialsAvatar
                        name={all_users[item.assigned_to]?.name}
                        id={`TooltipTop_reviewer_${index}`}
                        userColor={getUserColor(all_users[item.assigned_to]?.email)}
                        dimensions="40px"
                        marginBottom='0'
                    />
                    <UncontrolledTooltip placement="top" target={`TooltipTop_reviewer_${index}`}>
                      {all_users[item.assigned_to]?.name}
                    </UncontrolledTooltip>
                  </div>  :
                    <img src={profileImg} alt="default profile" style={{height:"40px", width:"40px"}}/>
                    )}
                  </Col>
                </Row>
              </CardItem>
            </div>
        )): <div>Loading</div>}
      </div>
    </div>
  </React.Fragment>)
}

export default RcaActionItemsList;